import axios from "axios";

const URL = {
    base: '/api/cdk/merchant/v1/',
}

const HEADERS = {
    "Content-Type": "application/json"
}

const MerchantsService = {
    getMerchants: async () => {

        try {

            const response = await axios.get(`${URL.base}`, {headers: HEADERS});
            const merchants = response.data;

            return merchants;

        } catch (e) {
            console.error('An error has occurred while trying to load the merchants', e);
            return {hasError: true};
        }

    }
}

export default MerchantsService;